<template>
  <div class="state">
    <div class="status">
      <img src="@/assets/images/icons/member/doing.png" v-if="state.status === 0 || state.status === 1">
      <img src="@/assets/images/icons/member/success.png" v-else-if="state.status === 2">
      <img src="@/assets/images/icons/member/fail.png" v-else-if="state.status === -1">
      <span v-if="state.status === 0">正在支付，请稍后..</span>
      <span v-else-if="state.status === 1">支付已受理，等待支付结果..</span>
      <span v-else-if="state.status === 2">支付成功！</span>
      <span v-else-if="state.status === -1">支付失败！</span>
    </div>
    <div class="divivd"></div>
    <div class="btn" @click.prevent="$router.replace({name: 'myAccount'})">返回</div>
  </div>
</template>

<script>
export default {
  name: 'RechargeStateZH',
  props: {
    state: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  }
}
</script>
<style scoped>
.state{
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  /*margin-top: -150px;*/
  /*margin-left: -28px;*/
  width: 100%;
}
.status{
  /*margin-bottom: 120px;*/
  margin-bottom: 36px;
  position: relative;
  /*padding-left: 56px;*/
  display: flex;
  justify-content: center;
}
.status img{
  width: 42px;
  height: 42px;
  /*position: absolute;*/
  /*top: 50%;*/
  /*left: 0;*/
  /*transform: translateY(-50%);*/
}
.status span{
  font-size: 16px;
  color: #333;
  margin-left: 15px;
  display: flex;
  align-items: center;
}
.divivd{
  height: 1px;
  background-color: #E9E9E9;
  width: 75%;
  margin: 0 auto 42px;
}
.btn {
  border: 1px solid #1F8AFD;
  border-radius: 3px;
  font-size: 13px;
  color: #1F8AFD;
  height: 32px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  width: 110px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/recharge/State.vue